export default __webpack_public_path__ + "static/media/Head.8ba56863.svg";